export class AnchorAnimation {
    public static init() {
        const hash = window.location.hash;
        if (hash) {
            window.history.scrollRestoration = 'manual';
            const elmnt = document.getElementById(hash.substring(1));
            elmnt.scrollIntoView(true);
        }
    }
}

$(() => {
    AnchorAnimation.init();
});